import { Chip } from '@mui/material';
import { tenantTypeConfigs } from 'TenantModule/constants';
import { DataCellProps } from '../types';

export const TenantTypeCell = ({ _customRowProps, tenant }: DataCellProps) => {
  const config = tenant.tenantType ? tenantTypeConfigs[tenant.tenantType] : undefined;

  if (!config) return <div />;

  return <Chip label={config.label} color={config.color} size="small" sx={{ fontWeight: 500 }} />;
};
